var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.$t('message.error.desc.systemErrorDesc')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }